type GTMEventCallback = () => void;

class GTMEvent {
    private readonly callback: undefined | GTMEventCallback;
    public readonly name: string;
    public readonly data: object;
    public readonly timestamp: number;
    public trackedTimestamp = 0;
    public tracked = false;

    constructor(name: string, data: object, callback?: () => void) {
        this.name = name;
        this.data = data;
        this.timestamp = new Date().getTime();

        if (typeof callback === "function") {
            this.callback = callback;
        }
    }

    public track = () => {
        if (this.tracked) {
            return false;
        }

        const timestamp = new Date().getTime();
        this.trackedTimestamp = timestamp;

        // Check if window.dataLayer exists
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ...this.data,
            event: this.name,
            event_created: this.timestamp,
            event_tracked: timestamp,
        });

        this.tracked = true;
        if (typeof this.callback === "function") {
            this.callback();
        }

        return true;
    };
}

export default GTMEvent;
